import templates from '/app/templates'

export default class Bubble {
  constructor({ onClick, handleWidgetOpen, widgetContainer, handleCallWindow, icon, widgetId }) {
    this.onClick = onClick
    this.widgetContainer = widgetContainer
    this.icon = typeof icon === 'string' ? { type: 'filled', value: icon } : icon
    this.handleWidgetOpen = handleWidgetOpen
    this.widgetId = widgetId

    this.styleNamespace = 'cce-widget__bubble'
    this.$element = document.createElement('div')
    this.$element.className = this.styleNamespace
    this.handleCallWindow = handleCallWindow
  }

  render(isWidgetOpened) {
    this.$element.innerHTML = templates.bubbleTemplate({ icon: this.icon, isWidgetOpened: isWidgetOpened })
    this.observeEvents()
  }

  triggerPublicEvent(eventName, data) {
    if (this.widgetContainer !== null) {
      this.widgetContainer.triggerPublicEvent(eventName, data)
    }
  }

  observeEvents() {
    document.querySelectorAll('button[name=ccewToggleWindow]').forEach((element) => {
      element.addEventListener('click', () => {
        if (element.classList.contains('cce-widget__window__header--close')) {
          const mainWindow = document.querySelector('.cce-widget__window')

          mainWindow.classList.remove('extendView')

          if (mainWindow && mainWindow.classList.contains('cce-widget__window--open')) {
            this.onClick()
          }
        } else {
          this.onClick()
        }
      })
    })
  }
}
